export const billingTitles = [
    "",
    "Fecha de pago",
    "Producto",
    "Número de factura",
    "Estado",
    "Precio base",
    "IVA",
    "Total"
];